import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessagesService } from '../core/services/messages/messages.service';
import { RequestServiceService } from '../core/services/request-service/request-service.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent {
  emailForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
  });
  submitted: boolean = false;
  constructor(private requestApiService: RequestServiceService, public router: Router,
    public messageservices: MessagesService) { }
    login(){
    localStorage.clear()
      this.router.navigate([`/`]);
    }
  onSubmit() {
    this.submitted = true
    if (this.emailForm.valid) {
      let data = {
        "email": this.emailForm.value.email,
        "otp_type": "forgot_password",
        "otp_entity": "merchant"
      }
      this.requestApiService.verifyEmail(data).then(response => {
        this.submitted = false
        if (response.success) {
          localStorage.setItem('authToken', response.data.token)
          localStorage.setItem('email', this.emailForm.value.email)
          this.router.navigate([`/forgot-password`]);
          this.messageservices.showNotification(response.msg, 'success', 'success');
        } else {
          this.messageservices.showNotification(response.msg, 'error', 'error');
        }
      });
    }
  }
}
